import { render } from "./ReadNews.vue?vue&type=template&id=080fd67d"
import script from "./ReadNews.vue?vue&type=script&lang=js"
export * from "./ReadNews.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__